import { Component, OnInit ,ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'app-creator',
  templateUrl: './creator.component.html',
  styleUrls: ['./creator.component.scss']
})
export class CreatorComponent implements OnInit {

  constructor(public cdr:ChangeDetectorRef) { 

  }

   public loadDynmicallyScript() {
        var script = document.createElement('script');
        script.src = "../assets/js/modernizr.custom.25376.js";
        script.async =false;
        document.head.appendChild(script);
        script.onload = () => console.log("Success---1  !!!");
       
         var script2 = document.createElement('script');
        script2.src = "../assets/js/classie.js";
        script2.async =false;
        document.head.appendChild(script2);
        script2.onload = () => console.log("Success---3  !!!");

          var script1 = document.createElement('script');
        script1.src = "../assets/js/menu.js";
        script1.async =false;
        document.head.appendChild(script1);
        script1.onload = () => console.log("Success---2  !!!");
     }



  ngOnInit() {
  	
  }
  ngAfterViewInit(){
  	this.loadDynmicallyScript();
             console.log("Script created successfully ------------- ");

  }


}
